import { render } from "./Filesync.vue?vue&type=template&id=7b1b9dad"
import script from "./Filesync.vue?vue&type=script&lang=js"
export * from "./Filesync.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__